import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import useApiUrls from "../../useApiUrls";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const AddCatelog = () => {
  const navigate = useNavigate();
  const { id, name } = useParams();
  const { getUrlByOperation } = useApiUrls();

  // State to hold form data
  const [formData, setFormData] = useState({
    catalogname: "",
    remark: "",
    active: true,
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page

    // const localStorageData = JSON.parse(localStorage.getItem("user"));
    // const token = localStorageData?.token;
    // const userid = localStorageData?.userid;
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const dataToSend = {
      catalogname: formData.catalogname,
      remark: formData.remark,
      active: formData.active,
    };

    try {
      const CatalogInsert = getUrlByOperation("CatalogInsert");
      await axios.post(
        CatalogInsert,
        dataToSend,
        {
          headers: {
            "X-Authorization": token,
            "UserId": userid,
            "Content-Type": "application/json",
          },
        }
      );
      setMessage("Catalogue added successfully!");

      // Navigate to another page after 3 seconds
      setTimeout(() => {
        navigate("/catelog");
      }, 3000);
    } catch (error) {
      setMessage("Failed to add Catalogue.");
    }
  };

  // Handle input change for text and file inputs separately
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Save text input value
    }));
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add Catalogue</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Catalogue Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.catalogname}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="catalogname"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Catalogue Description</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="remark"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select 
                                className="form-control" 
                                name="active" 
                                value={formData.active}
                                onChange={handleChange}
                              >
                                <option value={true}>Active</option>
                                <option value={false}>Deactive</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            Add
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "Catalog added successfully!" ? (
        <SuccessMessage message={message} />
      ) : (
        ""
      )}

      {message === "Failed to add catalog." ? (
       <FailedMessage message={message} />
      ) : (
        ""
      )}
    </>
  );
};

export default AddCatelog;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
